/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
import { FunctionPlugin } from './plugin/FunctionPlugin';
export { FunctionPlugin };
